import PageTitle from '../components/PageTitle';

const staff = [
  { role: 'CEO', name: 'Rob Walton', email: 'rob@vwzz.eu' },
  { role: 'Flight Operations Manager', name: 'Dejw A.', email: 'dejw@vwzz.eu' },
  { role: 'Flight Operations Support', name: 'Adam B.', email: 'adam@vwzz.eu', discord: 'Ath1uxx' },
  { role: 'Fleet Manager', name: 'Igor Z. (Benek)', email: 'igor@vwzz.eu', discord: 'benekq' },
  { role: 'Chief Pilot', name: 'Francisco B.', email: 'francisco@vwzz.eu', discord: 's0oda' },
  { role: 'Community Manager', name: 'Tudor M.', email: 'tudor@vwzz.eu', discord: 'haiper.2.0' },
];

export default function ContactPage() {
  return (
    <>
      <PageTitle>vWZZ - Contact Us</PageTitle>
      <div className="page-container">
        <h1 className="page-title">MEET THE CREW</h1>
        <p className="page-subtitle">Our staff team is here to assist you with any inquiries regarding operations or membership.</p>
        <div className="staff-grid">
          {staff.map((member) => (
            <article className="staff-card" key={member.email}>
              <div className="role-badge">{member.role}</div>
              <h3>{member.name}</h3>
              <div className="staff-details">
                <div className="detail-row"><span className="label">Email</span><a className="value contact-value" href={`mailto:${member.email}`}>{member.email}</a></div>
                {member.discord && <div className="detail-row"><span className="label">Discord</span><span className="value">{member.discord}</span></div>}
              </div>
            </article>
          ))}
        </div>
        <div className="general-inquiry">
          <h3>General Inquiries</h3>
          <p>For support tickets and general questions, please email:</p>
          <a href="mailto:staff@vwzz.eu" className="mail-link">staff@vwzz.eu</a>
        </div>
      </div>
    </>
  );
}
